// helpers/buildStatisticsConfig.ts
import dayjs from "dayjs";
import { StatisticsConfig } from "../../hooks/reporting/statistics/useStatistics";
import { ReportingMelcoMachineStatisticsModelsGroupListItem, ReportingMelcoMachineStatisticsModelsStatisticsListFilter } from "melco-shared-logic";

export const buildStatisticsConfig = (
    reports: ReportingMelcoMachineStatisticsModelsStatisticsListFilter,
    machineGroups: ReportingMelcoMachineStatisticsModelsGroupListItem[]
): StatisticsConfig => {
    const selectedMachineGroupIds = reports?.groupList
        ?.split(",")
        .map((s: string) => s.trim());

    const machineGroupsFilter =
        machineGroups
            ?.filter(
                (g) => g.id && selectedMachineGroupIds?.includes(g.id)
            )
            .map((g) => ({
                label: g.name!,
                value: g.id!,
            })) ?? [];

    const designsFilter =
        reports?.designList
            ?.split(",")
            .map((s: string) => s.trim())
            .filter(Boolean)
            .map((design: string) => ({
                label: design,
                value: design,
            })) ?? [];

    return {
        grouped: reports?.isGrouped,
        startTimestamp: dayjs(reports?.startDate).toDate(),
        endTimestamp: dayjs(reports?.endDate).toDate(),
        machineGroupsFilter,
        designsFilter,
    };
};
